import { MediaType } from 'types/campaign';

export function isWebOrTvMediaType(mediaType: MediaType): mediaType is MediaType.WEB | MediaType.TV {
  return mediaType === MediaType.WEB || mediaType === MediaType.TV;
}
